import { useEffect, useState } from "react";
import './styles.css';
import { Header } from "../../components/Header";
import { Sidebar } from "../../components/Sidebar";
import { Button, Col, Row } from "react-bootstrap";
import { TBody, TCell, TGroup, THeader, TRow, Table, ThCell } from "../../components/Table/Table";
import { FillPen } from "../../components/Icons";
import { Title } from "../../components/Title";
import { CardContent } from "../../components/CardContent";
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import api from "../../services/api";
import { Subtitle } from "../../components/SubTitle";

export function Quarentena() {
    const [documents, setDocuments] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        api.get(`get-docs-for-quarentena?page=${page}`).then((response) => {
            setDocuments(response.data.data);
            setTotalPages(response.data.meta.last_page);
        });
    }, [page]);

    return (
        <>
            <Sidebar />
            <Header route='./' />
            <div className="main">
                <div className='py-4'>
                    <CardContent>
                        <Title text="Quarentena" />
                        <Subtitle text="Escolha um PGR para analisar" />

                        <Row>
                            <Col md={12}>
                                <Table>
                                    <THeader>
                                        <ThCell>Empresa</ThCell>
                                        <ThCell>FDT</ThCell>
                                        <ThCell>Responsável</ThCell>
                                        <ThCell>Análises</ThCell>
                                        <ThCell>Ações</ThCell>
                                    </THeader>
                                    <TBody>
                                        {documents.map((doc:any) => (
                                            <TGroup key={doc.id}>
                                                <TRow>
                                                    <TCell>{doc.Empresas.nome}</TCell>
                                                    <TCell>{doc.fdt.nome}</TCell>
                                                    <TCell>{doc.PgrResponsaveis.nome}</TCell>
                                                    <TCell>{doc.quarentena_count}</TCell>
                                                    <TCell className="b-center">
                                                        <Button href={`pgr?empresa=${doc.company_id}&fdt=${doc.fdt_id}&revisao=${doc.revisao_id}`} className='btn btn-outline-primary btn-outline-main'>PGR
                                                            <AssignmentOutlinedIcon />
                                                        </Button>
                                                    </TCell>
                                                </TRow>
                                            </TGroup>
                                        ))}
                                    </TBody>
                                </Table>
                                <div className="pagination">
                                    <Button onClick={() => setPage(prev => prev - 1)} disabled={page === 1}>Anterior</Button>
                                    <Button onClick={() => setPage(prev => prev + 1)} disabled={page === totalPages}>Próximo</Button>
                                </div>
                            </Col>
                        </Row>
                    </CardContent>
                </div>
            </div>
        </>
    );
}
